module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/download-arrow-1afb477cc46879aed0744d92a2fffa0d.svg&quot;;"